import { METRIC_NAMES } from '@config/Consts';

class AgentViewModel {
  constructor(options) {
    this[METRIC_NAMES.AGENT_VIEW_AGENT_PICTURE] = options[METRIC_NAMES.AGENT_VIEW_AGENT_PICTURE];
    this[METRIC_NAMES.AGENT_VIEW_AGENT_STATUS] = options[METRIC_NAMES.AGENT_VIEW_AGENT_STATUS];
    this[METRIC_NAMES.AGENT_VIEW_STATUS_REASON] = options[METRIC_NAMES.AGENT_VIEW_STATUS_REASON];
    this[METRIC_NAMES.AGENT_VIEW_AGENT_NAME] = options[METRIC_NAMES.AGENT_VIEW_AGENT_NAME];
    this[METRIC_NAMES.AGENT_VIEW_AGENT_SKILLS] = options[METRIC_NAMES.AGENT_VIEW_AGENT_SKILLS];
    this[METRIC_NAMES.AGENT_VIEW_ASSIGNED_CONVERSATIONS] =
      options[METRIC_NAMES.AGENT_VIEW_ASSIGNED_CONVERSATIONS];
    this[METRIC_NAMES.AGENT_VIEW_CONCLUDED_CONVERSATIONS] =
      options[METRIC_NAMES.AGENT_VIEW_CONCLUDED_CONVERSATIONS];
    this[METRIC_NAMES.AGENT_VIEW_TRANSFER_RATE] = options[METRIC_NAMES.AGENT_VIEW_TRANSFER_RATE];
    this[METRIC_NAMES.AGENT_VIEW_AGENT_GROUP] = options[METRIC_NAMES.AGENT_VIEW_AGENT_GROUP];
    this[METRIC_NAMES.AGENT_VIEW_CLOSED_RATE] = options[METRIC_NAMES.AGENT_VIEW_CLOSED_RATE];
    this[METRIC_NAMES.AGENT_VIEW_PENDING_RATE] = options[METRIC_NAMES.AGENT_VIEW_PENDING_RATE];
    this[METRIC_NAMES.AGENT_VIEW_INTENTS_MATCHED_RATE] =
      options[METRIC_NAMES.AGENT_VIEW_INTENTS_MATCHED_RATE];
    this[METRIC_NAMES.AGENT_VIEW_ACTIVE_CONVERSATIONS] =
      options[METRIC_NAMES.AGENT_VIEW_ACTIVE_CONVERSATIONS];
    this[METRIC_NAMES.AGENT_VIEW_MAX_SLOTS] = options[METRIC_NAMES.AGENT_VIEW_MAX_SLOTS];
    this[METRIC_NAMES.AGENT_VIEW_AGENT_LOAD] = options[METRIC_NAMES.AGENT_VIEW_AGENT_LOAD];
    this[METRIC_NAMES.AGENT_VIEW_CLOSED_CONVERSATIONS] =
      options[METRIC_NAMES.AGENT_VIEW_CLOSED_CONVERSATIONS];
    this[METRIC_NAMES.AGENT_VIEW_AGENT_STATUS_DURATION] =
      options[METRIC_NAMES.AGENT_VIEW_AGENT_STATUS_DURATION];
    this[METRIC_NAMES.AGENT_VIEW_AGENT_STATUS_WITH_REASON_DURATION] =
      options[METRIC_NAMES.AGENT_VIEW_AGENT_STATUS_WITH_REASON_DURATION];
    this[METRIC_NAMES.AGENT_VIEW_CSAT] = options[METRIC_NAMES.AGENT_VIEW_CSAT];
    this[METRIC_NAMES.AGENT_VIEW_ONLINE_RATE] = options[METRIC_NAMES.AGENT_VIEW_ONLINE_RATE];
  }
}

export default AgentViewModel;
